import React from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useTranslation } from "react-i18next"
import CarsTable from "./CarsTable"

export default function CarsList() {
  const { t } = useTranslation()

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("Cars")} />
        <CarsTable />
      </div>
    </div>
  )
}
